<template>
  <div class="view-tasklists account-lookup">
    <user-menu />
    <div class="wrapper">
      <masteradmin-sidebar-menu v-if="masterAdmin == true" />
      <researcher-sidebar-menu v-if="researcher == true" />
      <CSRSidebarMenu v-if="csr == true" />
      <div class="content-wrapper">
      <div class="container-wrapper center" >

        <div class="col-12 override-padding">
          <div class="col-8 override-padding float-left">
          <h3 class="d-inline heading">
            Usage Report
          </h3>
          </div>
          <div class="col-4 override-padding float-right text-align-right">
            <router-link to="/report-dashboard">
            <button class="btn btn-red btn-md input-height-15 report-dashboard-link"><i class="fa fa-chevron-left" aria-hidden="true" style="padding-right: 10px;"></i> Back to Reporting Dashboard</button>
            </router-link>
          </div>
          <div style="clear: both"></div>
        </div>
        <div class="heading-seperator"></div>
        <div style="clear: both; float: none;" class="col-12 margin-bottom-10"></div>
      	<div class="col-12 override-padding">

        <div class="org_details">
          <div class="handle2 float-left col-lg-12 override-padding collapse-wrapper float-right" style="padding-top: 2px;" >
          <b-link v-b-toggle="'organization'" >
            <div>
              ORGANIZATION
              <i class="fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </b-link>
          </div>


          <b-collapse v-bind:id="'organization'" class="mt-2" visible >
          <div class="border-content float-left col-12 override-padding">
          <div class="col-md-4 float-left override-padding">
            <div class="col-12">
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >Affilifate:</label>
              </div>
              <div class="col-8 float-left override-padding">
                <b-form-select 
                    name="affiliate" 
                    class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                    v-model="affiliate"
                    :options="affiliate_options"
                    >
                    </b-form-select>
              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >Country:</label>
              </div>
              <div class="col-8 float-left override-padding">
                <div class="col-md-10 float-left padding-lr-5" style="padding-left: 0">
                  <b-form-select 
                    name="org_country" 
                    class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                    v-model="org_country"
                    :options="country_options"
                    v-on:change="getStateLists(org_country)">
                    </b-form-select>
                </div>
                <div class="col-md-2 float-left override-padding">
                  <button
                    v-on:click="updateCountryUS()"
                    class="col-12 btn btn-red edit-action-btn margin-bottom-5" style="margin-top: 2px"
                    >US</button>
              </div>
              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >Market Area:</label>
              </div>
              <div class="col-8 float-left override-padding">
                <b-form-select 
                    name="org_market_area" 
                    class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                    v-model="org_market_area"
                    :options="market_area_options"
                    >
                    </b-form-select>
              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >Status:</label>
              </div>
              <div class="col-8 float-left override-padding">
                <b-form-select 
                    name="org_status" 
                    class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                    v-model="org_status"
                    :options="org_status_options"
                    >
                    </b-form-select>
              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              
            </div>
          </div>

          <div class="col-md-4 float-left override-padding">
            <div class="col-12">
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >Account Type:</label>
              </div>
              <div class="col-8 float-left override-padding">
                <b-form-select 
                    name="account_type" 
                    class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                    v-model="account_type"
                    :options="account_type_options"
                    >
                    </b-form-select>
              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >State:</label>
              </div>
              <div class="col-8 float-left override-padding">
                <b-form-select 
                    name="org_state" 
                    class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                    v-model="org_state"
                    :options="state_options"
                    >
                    </b-form-select>
              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >NAICS ID:</label>
              </div>
              <div class="col-8 float-left override-padding">
                <b-form-select 
                    name="naics_id" 
                    class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                    v-model="naics_id"
                    :options="naics_id_options"
                    >
                    </b-form-select>
              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >Updated By:</label>
              </div>
              <div class="col-8 float-left override-padding">
                <b-form-select 
                    name="updated_by" 
                    class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                    v-model="updated_by"
                    :options="user_options"
                    >
                    </b-form-select>
              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              
            </div>
          </div>


          <div class="col-md-4 float-left override-padding">
            <div class="col-12">
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >Program:</label>
              </div>
              <div class="col-8 float-left override-padding">
                <b-form-select 
                    name="program" 
                    class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                    v-model="program"
                    :options="program_options"
                    >
                    </b-form-select>
              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >Zip:</label>
              </div>
              <div class="col-8 float-left override-padding">
                    <input
                      type="text"
                      name="org_zip"
                      id="org_zip"
                      class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                      v-model="org_zip"
                      maxlength="250" style="height: 38px;">

              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              
              <div class="col-4 float-left override-padding">
                <label
                    class="col-11 override-padding" >NAICS #(5 digit):</label>
              </div>
              <div class="col-8 float-left override-padding">
                  <div class="col-12 col-md-12 override-padding">
                    <div class="col-md-8 float-left padding-lr-5" style="padding-left: 0">
                    <input
                      type="text"
                      name="naics_code"
                      id="naics_code"
                      class="col-12 col-sm-12 input-height-30  margin-bottom-5"
                      v-model="naics_code"
                      maxlength="250" style="height: 38px;">
                    </div>
                    <div class="col-md-4 float-left override-padding">
                    <button
                        v-on:click="naicsListModal"
                        class="col-12 btn btn-red edit-action-btn margin-bottom-5" style="height: 38px;"
                        >NAICS</button>
                    </div>
                  </div>

              </div>
              <div style="clear: both; float: none;" class="col-12"></div>              
            </div>
          </div>

          </div>
          </b-collapse>
          </div>

          <div style="clear: both; float: none;" class="col-12"></div>  


        <div class="org_details" style="margin-top: 30px;">

          <div class="handle2 float-left col-lg-12 override-padding collapse-wrapper float-right" style="padding-top: 2px;" >
          <b-link v-b-toggle="'display-columns'" >
            <div>
              SELECT DISPLAY COLUMNS YOU WANT IN REPORT
              <i class="fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </b-link>
          </div>
          <b-collapse v-bind:id="'display-columns'" class="mt-2" visible >
          <div class="border-content float-left col-12 override-padding" style="padding-bottom: 30px;">

            <div class="col-md-8 float-left override-padding">
              <div class="col-12">
                <div class="display_column_fields">
                  <div class="col-6 float-left" style="padding-top: 0px;" >
                    <div v-for="(field, index) in org_display_fields">
                      <div v-if="index <=11">
                      <input
                        type="checkbox"
                        v-bind:id="'org_' + index"
                        v-bind:name="'org[' + index + ']'"
                        ref="is_enabled"
                        v-model="field.checked"
                        />
                      <label
                      class="">{{ field.text }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 float-left" style="padding-top: 0px;" >
                    <div v-for="(field, index) in org_display_fields">
                      <div  v-if="index > 11">
                      <input
                        type="checkbox"
                        v-bind:id="'org_' + index"
                        v-bind:name="'org[' + index + ']'"
                        ref="is_enabled"
                        v-model="field.checked"
                        />
                      <label
                      class="">{{ field.text }}</label>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>


          </div>
          </b-collapse>

        </div>
        <div style="clear: both;" class="margin-bottom-20"></div>
        <div class="col-12 override-padding">
            <button
                v-on:click="runReport()"
                class="btn btn-red btn-lg input-height-15"
                >Run Report</button>
            <button
                v-on:click="clearSearchAction()"
                class="btn btn-grey btn-lg input-height-15" style="margin-left: 15px;"
                >Clear Search</button>
            <button
                v-if="account_lists.length > 0"
                v-on:click="exportCSVAction()"
                class="btn btn-red btn-lg input-height-15 float-right"
                style="margin-left: 15px;"
                >Export CSV</button>

        </div>

        <div class="margin-bottom-10"></div>
        <div id="list-view">
          <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
          <div v-if="listView" class="col-12 override-padding account-lookup-view-list" >
            <div class="col-12 override-padding" style="padding-bottom: 5px; padding-top: 20px;" >
              <h1 style="font-size: 27px;">List View</h1>
            </div>
            <div class="col-12 float-left override-padding pagination-wrapper" v-if="account_lists.length > 0">
            <PaginationTop
              ref="PaginationTop"
              :currentPage="currentPage"
              :totalRows="rows"
              :perPage="perPage"
              :showPaginatedFunction="showNaicsofPaginatedTop"
              :showPerPageFunction="perPagePaginatedTop"
              :totalPages="totalPages"
              :sNo="sno"
            >
            </PaginationTop>
            </div>
            <div class="row account_view_list_heading_row col-12" style="overflow: scroll;">
              <table border="0" cellpadding="5" class="view-lists col-12">
                <tr>
                  <th class="field_title">SI.NO</th>
                  <th class="field_title" style="padding-right: 5px;" v-for="(header, hindex) in headers">
                    <span v-if="header.sort == true">
                      <span class="bold cursor-pointer" v-on:click="sortMethod(header.alias)">
                      {{ header.heading }}
                      <span class="float-right padding-right-5 color-000">
                        <i v-if="sortField == header.alias && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                        <i v-if="sortField == header.alias && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                        <i v-if="sortField != header.alias" class="fa fa-sort" aria-hidden="true"></i>
                      </span>
                      </span>
                    </span>
                    <span class="bold" v-else>
                      {{ header.heading }}
                    </span>

                  </th>
                </tr>
                <tr v-for="(account_list, index) in account_lists" class="tasklist-row" v-if="account_lists.length > 0" v-on:click="router_redirect(account_list.accId, account_list.isEnterprise)">
                  <td>{{ sno + index + 1 }}</td>
                  <td v-for="(header) in headers">{{ getValue(account_list, header.alias) }}</td>
                </tr>
                <tr v-if="account_lists.length == 0">
                  <td :colspan="parseInt(headers.length + 1)">
                    No Accounts Found
                  </td>
                </tr>
              </table>
            </div>

            <div class="col-12 float-left override-padding pagination-wrapper" style="padding-bottom: 15px; padding-top: 15px;" v-if="account_lists.length > 0">
              <Pagination
                ref="Pagination"
                :currentPage="currentPage"
                :totalRows="rows"
                :perPage="perPage"
                :showPaginatedFunction="showNaicsofPaginated"
                :showPerPageFunction="perPagePaginated"
                :totalPages="totalPages"
                :sNo="sno"
              >
              </Pagination>
            </div>
          </div>
        </div>



        <NaicsList :isModalVisible="isNaicsModalVisible" @close="isNaicsModalVisible = false">
          <div slot="header" class="sub-heading">
          </div>
          <div slot="body">
          </div>
          <div slot="footer" class="col-3 override-padding">
          </div>
        </NaicsList>


        <BatchModal :isModalVisible="isExportModalVisible" @close="isExportModalVisible = false">
          <span v-if="loading" class="pull-right text-danger">
            Loading...
          </span>
          <div slot="header" class="sub-heading"></div>
          <div slot="body">
            <div class="">
              <div class="export-details">
                Exported: {{ rowsExportedCSV }} of {{ rowsCSV}}
              </div>
              <div class="percentage-text">
                {{ percentage }}
              </div>
              <div class="batch-box">
                <div class="batch-loading" id="batch-loading" >
                  &nbsp;
                </div>
              </div>
              <div class="download-link" @click="downloadFunc()" v-if="percentage == '100%'">
                Download CSV File
              </div>
            </div>
          </div>
          <div slot="footer" class="col-3 override-padding">

          </div>
        </BatchModal>


    </div>
  </div>
  </div>
  </div>
  </div>

</template>

<script>

import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import NaicsList from './../account_lookup_naics_list.vue';
import UserMenu from '../../shared/user_menu.vue';
import MasteradminSidebarMenu from '../../shared/masteradmin_sidebar_menu.vue';
import { store } from '../../../store/store';
import router from '../../../router/index.js';
import Pagination from '../../pagination.vue';
import PaginationTop from '../../pagination.vue';
import ResearcherSidebarMenu from '../../shared/researcher_sidebar_menu.vue';
import CSRSidebarMenu from '../../shared/csr_sidebar_menu.vue';
import BatchModal from './report_loading_modal.vue';

export default {
        props: ['type'],
        data() {
          return {
            org_display_fields: [],
            lookup_type: '',
            lookup_type_options: [
              { value: '', text: '-Any-' },
              { value: 'Account', text: 'Account' },
              { value: 'Enterprise', text: 'Enterprise' },
            ],
            account_type: '',
            account_type_options: [
              { value: '', text: '-Any-' },
              { value: 'Company', text: 'Company' },
              { value: 'School', text: 'School' },
            ],
            org_country: '',
            ind_country: '',
            org_state: '',
            ind_state: '',
            org_market_area: '',
            market_area_options: [
              { value: '', text: '-Any-' },
            ],
            country_options: [],
            state_options: [
              { value: '', text: '-Any-' },
            ],
            program: '',
            program_options: [
              { value: '', text: '-Any-' },
              { value: 'Mentorship', text: 'Mentorship' },
              { value: 'Apprenticeship', text: 'Apprenticeship' },
              { value: 'Mentorship & Apprenticeship', text: 'Mentorship & Apprenticeship' },
            ],
            org_status: 'Active',
            org_status_options: [
              { value: '', text: '-Any-' },
              { value: 'Prospect', text: 'Prospect' },
              { value: 'Active', text: 'Active' },
              { value: 'Inactive', text: 'Inactive' },
              { value: 'Delete', text: 'Deleted' },
            ],
            affiliate_options: [],
            affiliate: '',
            updated_by: '',
            user_options: [],
            naics_id: '',
            naics_id_options: [], 
            org_zip: '',
            ind_zip: '',
            naics_code: '',
            isNaicsModalVisible: false,
            apiUrl: '',
            researcher: false,
            masterAdmin: false,
            csr: false,
            rows: 0,
            perPage: 100,
            currentPage: 1,
            loading: false,
            sortField: '',
            sortBy: '',
            searchParameters: {},
            sno: 0,
            pageOptions: [],
            totalPages: 0,
            totalCSVPages: 0,
            perCSVPage: 500,
            rowsCSV: 0,
            rowsExportedCSV: 0,
            account_lists: [],
            listView: false,
            isExportModalVisible: false,
            percentage: '0%',
            fileName: '',
          }
        },
        components: {
          NaicsList,
          UserMenu,
          MasteradminSidebarMenu,
          Pagination,
          PaginationTop,
          ResearcherSidebarMenu,
          CSRSidebarMenu,
          BatchModal,
        },
        methods: {
          getValue: function(accountList, key) {
            return accountList[key];
          },
          clearSearchAction: function(){
            this.account_lists = [];
            this.listView = false;
            this.account_type = '';
            this.program = '';
            this.org_country = '';
            this.org_state = '';
            this.state_options = [];
            this.state_options = [{ value: '', text: '-Any-' }];
            this.org_zip = '';
            this.org_market_area = '';
            this.naics_id = '';
            this.naics_code = '';
            this.org_status = 'Active';
            this.updated_by = '';
            this.affiliate = '';
            this.currentPage = 1;
            this.perPage = 100;
            if((this.listView == true) && (this.account_lists.length > 0)) {
              this.$refs.Pagination.currentPageValue = 1;
              this.$refs.PaginationTop.currentPageValue = 1;
              this.$refs.PaginationTop.perPageValue = 100;
              this.$refs.Pagination.perPageValue = 100;
            }

            this.getUsageReportDisplayFields();
          },

          router_redirect: function(accountId, type) {
            if(type == false) {
              let routeData = this.$router.resolve({name: 'accountlookupdetail', params: {account_id: accountId}});
              window.open(routeData.href, '_blank');
            }
            else {
              let routeData = this.$router.resolve({name: 'enterpriselookupdetail', params: {account_id: accountId}});
              window.open(routeData.href, '_blank');
            }
            
          },
          downloadFunc: function() {
              var url = this.apiUrl + '/custom/csv-view/' + this.fileName + '/Usage';
              window.location.href = url;
              this.isExportModalVisible = false;
              return false;
          },

          getAccountType: function() {
            if(this.lookup_type == 'Account') {
              this.account_type = '';
              this.account_type_options = [
                { value: '', text: '-Any-' },
                { value: 'Company', text: 'Company' },
                { value: 'School', text: 'School' },
            ];
            } else if(this.lookup_type == 'Enterprise') {
              this.account_type = '';
              this.account_type_options = [
              { value: '', text: '-Any-' },
                { value: 'Manage', text: 'Manage' },
                { value: 'Readonly', text: 'Read Only' },
            ];
            } else {
              this.account_type = '';
              this.account_type_options = [
                { value: '', text: '-Any-' },
            ];
            }
          },
          closeModal() {
            this.$emit('close');
          },
          naicsListModal: function() {
            this.isNaicsModalVisible = true;
          },
          naicsValuesAction: function(naicslist) {
            this.naics_id = naicslist.naicsId;
            this.naics_code = naicslist.naicsCode.toString();
            this.isNaicsModalVisible = false;
          },
          getCountryLists: function () {
            axios.get('/get-country-lists', {

            })
            .then(response =>  {
              this.country_options = response.data;
              this.country_options[0].text = '-Any-';
            })
            .catch(function(error) {

            });
          },
          getMarketAreaLists: function () {
            axios.get('/get-market-area-lists', {

            })
            .then(response =>  {
              this.market_area_options = response.data;
              this.market_area_options[0].text = '-Any-';
            })
            .catch(function(error) {

            });
          },
          getStateLists: function (CountryCode) {
            this.org_state = [];
            this.org_state = '';
            axios.get('/get-state-lists/' + CountryCode, {

            })
            .then(response =>  {
              this.state_options = response.data;
              this.state_options[0].text = '-Any-';
            })
            .catch(function(error) {

            });
          },
          updateCountryUS: function() {
            this.org_country = 'US';
            this.getStateLists(this.org_country);
          },
          getIndStateLists: function (CountryCode) {
            this.ind_state = [];
            this.ind_state = '';
            axios.get('/get-state-lists/' + CountryCode, {

            })
            .then(response =>  {
              this.ind_state_options = response.data;
              this.ind_state_options[0].text = '-Any-';
            })
            .catch(function(error) {

            });
          },
          updateIndCountryUS: function() {
            this.ind_country = 'US';
            this.getIndStateLists(this.ind_country);
          },
           fetchUserOptions: function() {
             axios.get('/masteradmin-researcher-useroptions', {

             })
             .then((response) => {
                 var user_option = {value: '', text: '-Any-'};
                 this.user_options.push(user_option);
                 for(var i=0; i < response.data.length; i++) {
                   var name = response.data[i].first_name + ' ' + response.data[i].last_name;
                   var user_option = {value: response.data[i].id, text: name};
                   this.user_options.push(user_option);
                 }
             })
             .catch(error => {

             });

           },
           fetchAffiliateOptions: function() {
             axios.get('/affiliateoptions', {

             })
             .then((response) => {
                  var affiliate_option = {value: '', text: '-Any-'};
                  this.affiliate_options.push(affiliate_option);
                 for(var i=0; i < response.data.length; i++) {
                   var affiliate_option = {value: response.data[i].id, text: response.data[i].name};
                   this.affiliate_options.push(affiliate_option);
                 }
             })
             .catch(error => {

             });

           },

          getUsageReportDisplayFields: function() {
            axios('/usage-report-display-fields',
             {
                method: 'GET',
             },
            )
            .then(response => {
                this.org_display_fields = response .data.orgDisplayFields;
             })
            .catch(error => {

            });

          },
          showNaicsofPaginated() {
            this.currentPage = this.$refs.Pagination.currentPageValue;
            this.$refs.PaginationTop.currentPageValue = this.currentPage;
            this.fetchAccountList();
          },
          perPagePaginated() {
            this.currentPage = 1;
            this.$refs.Pagination.currentPageValue = 1;
            this.perPage = this.$refs.Pagination.perPageValue;
            this.$refs.PaginationTop.perPageValue = this.perPage;
            this.$refs.PaginationTop.currentPageValue = 1;
            this.fetchAccountList();
          },
          showNaicsofPaginatedTop() {
            this.currentPage = this.$refs.PaginationTop.currentPageValue;
            this.$refs.Pagination.currentPageValue = this.currentPage;
            this.fetchAccountList();
          },
          perPagePaginatedTop() {
            this.currentPage = 1;
            this.$refs.PaginationTop.currentPageValue = 1;
            this.perPage = this.$refs.PaginationTop.perPageValue;
            this.$refs.Pagination.perPageValue = this.perPage;
            this.$refs.Pagination.currentPageValue = 1;
            this.fetchAccountList();
          },
          sortMethod: function(field) {
            this.sortField = field;
            if(this.sortBy == 'ASC') {
              this.sortBy = 'DESC';
            }
            else {
              this.sortBy = 'ASC';
            }
            if(this.listView == true) {
              this.$refs.PaginationTop.currentPageValue = 1;
              this.$refs.Pagination.currentPageValue = 1;
            }
            this.fetchAccountList();
          },
          runReport: function() {
            this.currentPage = 1;
            this.perPage = 100;
            this.sortField = '';
            this.sortBy = '';
            if((this.listView == true) && (this.account_lists.length > 0)) {
              this.$refs.PaginationTop.perPageValue = 100;
              this.$refs.Pagination.perPageValue = 100;
              this.$refs.PaginationTop.currentPageValue = 1;
              this.$refs.Pagination.currentPageValue = 1;
            }
            this.fetchAccountList();
          },

          fetchAccountList: function() {
            this.loading = true;
            this.searchParameters = {};
            this.searchParameters.account_type = this.account_type;
            this.searchParameters.program = this.program;
            this.searchParameters.org_country = this.org_country;
            this.searchParameters.org_state = this.org_state;
            this.searchParameters.org_zip = this.org_zip;
            this.searchParameters.org_market_area = this.org_market_area;
            this.searchParameters.naics_id = this.naics_id;
            this.searchParameters.naics_code = this.naics_code;
            this.searchParameters.org_status = this.org_status;
            this.searchParameters.updated_by = this.updated_by;
            this.searchParameters.affiliate = this.affiliate;

            this.searchParameters.page = this.currentPage;
            this.searchParameters.perPage = this.perPage;

            this.searchParameters.sortField = this.sortField;
            this.searchParameters.sortBy = this.sortBy;

            var searchParam = this.search_parameters;
            axios("/usage-report-lists", {
              method: 'POST',
              data: {
                search_parameters: this.searchParameters,
                org_display_fields: this.org_display_fields,
              }
            })
            .then(response => {
              this.loading = false;
              this.account_lists = response.data.data;
              this.headers = response.data.header;
              this.currentPage = response.data.page;
              if(this.currentPage > 1) {
                this.sno = this.perPage * (this.currentPage - 1);
              }
              else {
                this.sno = 0;
              }
              this.rows = response.data.total_rows;
              this.totalPages = response.data.total_pages;
              this.listView = true;
              this.$refs.PaginationTop.totalPagesValue = this.totalPages;
              this.$refs.Pagination.totalPagesValue = this.totalPages;
              this.$refs.PaginationTop.getPageOptions();
              this.$refs.Pagination.getPageOptions();
              const tabScroll = document.getElementById("list-view");
              window.scrollTo({
                'behavior': 'smooth',
                'left': 0,
                'top': tabScroll.offsetTop + 80
              });

              if(this.account_lists.length == 0) {
                this.flash({ message: "No accounts found.", variant: 'danger' });
                
                
              }
            })
            .catch(error => {

            });
          },
          exportCSVAction: function() {
            this.isExportModalVisible = false;
            this.currentCSVPage = 1;
            this.rowsCSV = 0;
            this.rowsExportedCSV = 0;
            this.totalCSVPages = 0;
            this.percentage = 0;
            this.fileName = '';
            this.fetchAccountListCSV();
          },
          fetchAccountListCSV: function() {
            this.searchParameters = {};
            this.searchParameters.account_type = this.account_type;
            this.searchParameters.program = this.program;
            this.searchParameters.org_country = this.org_country;
            this.searchParameters.org_state = this.org_state;
            this.searchParameters.org_zip = this.org_zip;
            this.searchParameters.org_market_area = this.org_market_area;
            this.searchParameters.naics_id = this.naics_id;
            this.searchParameters.naics_code = this.naics_code;
            this.searchParameters.org_status = this.org_status;
            this.searchParameters.updated_by = this.updated_by;
            this.searchParameters.affiliate = this.affiliate;

            this.searchParameters.page = this.currentCSVPage;
            this.searchParameters.perPage = this.perCSVPage;
            this.searchParameters.fileName = this.fileName;

            this.searchParameters.sortField = this.sortField;
            this.searchParameters.sortBy = this.sortBy;

            var searchParam = this.search_parameters;
            axios("/usage-report-lists-csv", {
              method: 'POST',
              data: {
                search_parameters: this.searchParameters,
                org_display_fields: this.org_display_fields,
              }
            })
            .then(response => {
              this.isExportModalVisible = true;
              this.currentCSVPage = response.data.page;
              this.rowsCSV = response.data.total_rows;
              this.rowsExportedCSV = response.data.total_rows_exported;
              this.totalCSVPages = response.data.total_pages;
              this.percentage = response.data.percentage;
              this.fileName = response.data.file_name;
              document.getElementById("batch-loading").style.width = this.percentage;
              if(this.currentCSVPage <= this.totalCSVPages) {
                this.fetchAccountListCSV();
              }
              
            })
            .catch(error => {

            });

          },



        },
        created() {
          this.apiUrl = process.env.API_ENDPOINT;
          this.getCountryLists();
          this.getMarketAreaLists();
          this.fetchAffiliateOptions();
          this.fetchUserOptions();
          this.getUsageReportDisplayFields();
          var roles = this.$store.state.roles;
          if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
            this.masterAdmin = true;
          }
          if(roles.indexOf('ROLE_RESEARCHER') > -1) {
            this.researcher = true;
          }
          if(roles.indexOf('ROLE_CSR') > -1) {
            this.csr = true;
          }
          axios('/naicsids',
           {
              method: 'GET',
           },
          )
          .then(response => {
              this.naics_id_options.push({value: '', text: '-Any-'});
              for(var i=0; i < response.data.length; i++) {
                var naicsIdOption = {value: response.data[i].id, text: response.data[i].title};
                this.naics_id_options.push(naicsIdOption);
              }
           })
          .catch(error => {

          });





        },

    }

</script>
<style scoped>
@import '../../../assets/styles/account_lookup.css';

.view-accountlist {
  min-height: 70vh;
}
.view-accountlist .tasklist-row:last-child{
  border-bottom: 1px solid #E5E5E5;
}
.account_view_list_heading_row {
  background: none;
}
  label {
    padding-top: 8px;
  }
  .border-content {
    border: 1px solid #CCC;
    padding-top: 10px;
    border-top: 0;
  }
  .display_column_heading {
    background-color: #00ACEE;
    border: 1px solid #00ACEE;
    font-weight: bold;
    padding: 5px 20px;
    margin-top: 2px;
    color: #FFF;
  }
  .collapse-wrapper {
    background-color: #00ACEE;
    border: 1px solid #00ACEE;
    font-weight: bold;
    padding: 5px 10px;
    margin-top: 2px;
  }
  .collapse-wrapper a, .collapse-wrapper a:hover{ 
    color: #FFF;
    text-decoration: none;
    padding-top: 5px;
    display: inherit;
  }
  .collapse-wrapper i {
    float: right;
    font-size: 18px;
    font-weight: bold;
    padding-top: 0px;
    color: #FFF;
  }

tr th {
    /* background-color: #dc2227; */
    background-color: #00ACEE;
    line-height: 25px;
    color: #FFF;
    padding: 3px 0px;
    margin-right: 0px !important;
    margin-left: 0px !important;
}
tr td {
  color: #212529;
}
.account-lookup-view-list .field_title {
    width: auto;
    border-right: 1px solid #b6b6b6;
    padding-left: 5px;
    padding-right: 5px;
}
.view-lists {
  width: 100%;
}
.custom-select {
  height: 38px;
}
.report-dashboard-link {
  text-transform: uppercase;
}
.report-dashboard-link .fa-chevron-left {
  font-size: 13px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/reports/usage_report.vue